import { useClusterSession } from '../../auth/ClusterSessionProvider';
import { useI18n } from '../../i18n/useI18n';
import { Alert } from '../../ui/Alert';
import { NoticeScreen } from '../../ui/AuthLayout';
import { Button } from '../../ui/primitives';

/**
 * Signed in through the tenancy's identity provider, and in no group this
 * cluster grants rights to.
 *
 * Deliberately not a provider problem to solve: whoever runs that identity
 * provider adds the group, and if that is the tenancy itself, nobody has to ask
 * us at all. The group the cluster looks for was fixed when the tenancy was
 * declared and does not move when the provider does — so the answer is always
 * at the provider's end.
 */
export function ClusterNoAccessScreen() {
  const { t } = useI18n();
  const { session, signOut } = useClusterSession();

  return (
    <NoticeScreen>
      <Alert tone="deny" title={t('clusterNoAccess.title')} live>
        <p>{t('clusterNoAccess.body')}</p>
        {session !== null && (
          <>
            <p style={{ marginTop: 8 }} className="mono">
              {session.actor.subject}
            </p>
            {session.actor.groups.length > 0 && (
              <p style={{ marginTop: 8 }} className="mono">
                {session.actor.groups.join(' ')}
              </p>
            )}
          </>
        )}
      </Alert>

      <div style={{ marginTop: 22 }}>
        <Button
          variant="ghost"
          block
          onClick={() => {
            void signOut();
          }}
        >
          {t('common.signOut')}
        </Button>
      </div>
    </NoticeScreen>
  );
}
